import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import SearchIcon from '@mui/icons-material/Search';

import Loading from '../../common/Loading';
import Error from '../../common/Error';
import CustomerLoadsEditSupplierLookup from './CustomerLoadsEditSupplierLookup';
import CustomerLoadsEditReelTypeLookup from './CustomerLoadsEditReelTypeLookup';
import CustomerLoadsEditReelLookup from './CustomerLoadsEditReelLookup';
import CustomerLoadsEditProductLookup from './CustomerLoadsEditProductLookup';
import CustomerLoadsEditTrackerLookup from './CustomerLoadsEditTrackerLookup';

import CustomerLoadsEditUomList from './CustomerLoadsEditUomList';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function CustomerLoadsEdit(props) {
    //console.debug("RTS Break CustomerLoadsEdit");

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const history = useNavigate();
    //const display = props.display;
    const mode = props.mode;

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const [showReelTypeModal, setShowReelTypeModal] = useState(false);
    const [showReelModal, setShowReelModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);
    const [showTrackerModal, setShowTrackerModal] = useState(false);

    const [supplier, setSupplier] = useState(null);
    const [assignedToLink, setAssignedToLink] = useState(null);
    const [contractToLink, setContractToLink] = useState(null);
    const [product, setProduct] = useState(null);
    const [reel, setReel] = useState(null);
    const [tracker, setTracker] = useState(null);
    const [customerReel, setCustomerReel] = useState(null);
    const [project, setProject] = useState(null);
    const [shipDate, setShipDate] = useState();
    const [amt, setAmt] = useState(0);
    const [uom, setUom] = useState('ft');
    const [price, setPrice] = useState(0)
    const [shipToName, setShipToName] = useState('');
    const [shipToAddress1, setShipToAddress1] = useState('');
    const [shipToAddress2, setShipToAddress2] = useState('');
    const [shipToCity, setShipToCity] = useState('');
    const [shipToRegion, setShipToRegion] = useState('');
    const [shipToZip, setShipToZip] = useState('');
    const [deferralPeriod, setDeferralPeriod] = useState(0);
    const [netWeight, setNetWeight] = useState('');
    const [tareWeight, setTareWeight] = useState('');
    const [grossWeight, setGrossWeight] = useState('');
    const [customerPo, setCustomerPo] = useState('');
    const [customerMaterialNo, setCustomerMaterialNo] = useState('');
    const [idSapPo, setIdSapPo] = useState('');
    const [idSapBol, setIdSapBol] = useState('');
    const [idSapPackingList, setIdSapPackingList] = useState('');
    const [idSapBatchNo, setIdSapBatchNo] = useState('');
    const [reelType, setReelType] = useState();
    const [markDate, setMarkDate] = useState();
    const [markUser, setMarkUser] = useState();
    const [markEmptyScrap, setMarkEmptyScrap] = useState();
    const [markWeight, setMarkWeight] = useState();
    const [pickupRequestDate, setPickupRequestDate] = useState();
    const [pickupRequest, setPickupRequest] = useState();
    const [returnedDate, setReturnedDate] = useState();
    const [status, setStatus] = useState(1);


    const fetchData = useCallback((pIdGuid) => {
        let apiURL = apiRoot + "/Loads/GetLoadById/" + pIdGuid;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setSupplier(response.data.supplier);
                setAssignedToLink(response.data.assignedToLink);
                setContractToLink(response.data.contractToLink);
                setProduct(response.data.product);
                setReel(response.data.reel);
                setTracker(response.data.tracker);
                setCustomerReel(response.data.customerReel);
                setProject(response.data.project);
                setShipDate(response.data.shipDate!=null?new Date(response.data.shipDate):null);
                setAmt(response.data.amt);
                setUom(response.data.uom != null?response.data.uom.toLowerCase():'ft');
                setPrice(response.data.price!=null?response.data.price:0)
                setShipToName(response.data.shipToName!=null?response.data.shipToName:'');
                setShipToAddress1(response.data.shipToAddress1!=null?response.data.shipToAddress1:'');
                setShipToAddress2(response.data.shipToAddress2!=null?response.data.shipToAddress2:'');
                setShipToCity(response.data.shipToCity!=null?response.data.shipToCity:'');
                setShipToRegion(response.data.shipToRegion!=null?response.data.shipToRegion:'');
                setShipToZip(response.data.shipToZip!=null?response.data.shipToZip:'');
                setDeferralPeriod(response.data.deferralPeriod);
                setNetWeight(response.data.netWeight!=null?response.data.netWeight:'');
                setTareWeight(response.data.tareWeight!=null?response.data.tareWeight:'');
                setGrossWeight(response.data.grossWeight!=null?response.data.grossWeight:'');
                setCustomerPo(response.data.customerPo!=null?response.data.customerPo:'');
                setCustomerMaterialNo(response.data.customerMaterialNo!=null?response.data.customerMaterailNo:'');
                setIdSapPo(response.data.idSapPo!=null?response.data.idSapPo:'');
                setIdSapBol(response.data.idSapBol!=null?response.data.idSapBol:'');
                setIdSapPackingList(response.data.idSapPackingList!=null?response.data.idSapPackingList:'');
                setIdSapBatchNo(response.data.idSapBatchNo!=null?response.data.idSapBatchNo:'');
                setReelType(response.data.reelType);
                setMarkDate(response.data.markDate);
                setMarkUser(response.data.markUser);
                setMarkEmptyScrap(response.data.markEmptyScrap);
                setMarkWeight(response.data.markWeight);
                setPickupRequestDate(response.data.pickupRequestDate);
                setPickupRequest(response.data.pickupRequest);
                setReturnedDate(response.data.returnedDate);
                setStatus(response.data.status);

                setIsLoading(false);
            }
        })
        .catch(error => {
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token]); 
    
    
    useEffect(() => {
        if(mode === 1){
            fetchData(props.idGuid);
        }
        else{
            setIsLoading(false);
        }
    }, [mode, fetchData, props.idGuid]);  


    function handleSubmit(e) {
        e.preventDefault();
 
        let apiObj = {
            IdGuid: props.idGuid,
            Supplier: supplier,
            SoldToCustomer: sessionCustomer.customer,
            AssignedToCustomer: sessionCustomer.customer,
            ShipToCustomer: sessionCustomer.customer,
            ShipFromPlant: {Id:-1},
            Product: product,
            ReelType: reelType,
            Reel: reel,
            AssignedToLink: assignedToLink,
            ContractToLink: contractToLink,
            CustomerProject: project,
            Tracker: tracker,
            CustomerVisibleFlag: 1,
            CustomerReel: customerReel,
            Amt: amt,
            Uom: uom,
            Price: price,
            ShipDate: shipDate,
            ShipToName: shipToName,
            ShipToAddress1: shipToAddress1,
            ShipToAddress2: shipToAddress2,
            ShipToCity: shipToCity,
            ShipToRegion: shipToRegion,
            ShipToZip: shipToZip,
            ShipToGeoLat: null,
            ShipToGeoLng: null,
            DeferralPeriod: deferralPeriod,
            NetWeight: netWeight,
            TareWeight: tareWeight,
            GrossWeight: grossWeight,
            CustomerPo: customerPo,
            CustomerMaterialNo: customerMaterialNo,
            IdSapPo: idSapPo,
            IdSapBol: idSapBol,
            IdSapPackingList: idSapPackingList,
            IdSapBatchNo: idSapBatchNo,
            Status: status,
            MarkDate: markDate,
            MarkUser: markUser,
            MarkEmptyScrap: markEmptyScrap,
            MarkWeight: markWeight,
            PickupRequestDate: pickupRequestDate,
            PickupRequest: pickupRequest, 
            ReturnedDate: returnedDate,
            modifyUser: user.userName
        }

        if(apiObj.ReelType === null){
            setErrorTitle("Validation Error");
            setErrorBody("ReelType is required");
            setShowErrorModal(true);
            return;
        }

        if(apiObj.Product === null){
            setErrorTitle("Validation Error");
            setErrorBody("Product is required");
            setShowErrorModal(true);
            return;
        }

        if(apiObj.Amt === null || apiObj.Amt === 0){
            setErrorTitle("Validation Error");
            setErrorBody("Length is required and must be greater than 0");
            setShowErrorModal(true);
            return;
        }

        if(apiObj.Uom === null){
            setErrorTitle("Validation Error");
            setErrorBody("Unit of  Measure is required");
            setShowErrorModal(true);
            return;
        }

        if(apiObj.ShipDate === undefined || apiObj.ShipDate === null){
            setErrorTitle("Validation Error");
            setErrorBody("Ship Date is required");
            setShowErrorModal(true);
            return;
        }



        if(mode > 0){
            let apiURL = apiRoot + "/Loads/UpdateLoad/" + props.idGuid;
            axios
            .put(
                apiURL,
                apiObj, 
                {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
            )
            .then(response => {
                history(-1);
            })
            .catch(error => {
                setErrorTitle("Update Error");
                setErrorBody("An error has occured.  Please review the console log for details.");
                console.log("RTS UpdateLoad Error", error);
                setShowErrorModal(true);
            });
        }
        else{
            apiObj.createUser = user.userName;
            let apiURL = apiRoot + "/Loads/CreateLoad";
            axios
            .post(
                apiURL,
                apiObj, 
                {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
            )
            .then(response => {
                history(-1);
            })
            .catch(error => {
                setErrorTitle("Insert Error");
                setErrorBody("An error has occured.  Please review the console log for details.");
                console.log("RTS CreateLoad Error", error);
                setShowErrorModal(true);
            });
        }
    } 


    function setSupplierVal(pValue){
        setSupplier(pValue);
        setShowSupplierModal(false);
        props.setFormDirtyFx(1);
    };   

    function setReelTypeVal(pValue){
        setReelType(pValue);
        setShowReelTypeModal(false);
        props.setFormDirtyFx(1);
    };      

    function setReelVal(pValue){
        setReel(pValue);
        setShowReelModal(false);
        props.setFormDirtyFx(1);
    };  

    
    function setProductVal(pValue){
        setProduct(pValue);
        setShowProductModal(false);
        props.setFormDirtyFx(1);
    }; 

    
    function setTrackerVal(pValue){
        setTracker(pValue);
        setShowTrackerModal(false);
        props.setFormDirtyFx(1);
    }; 
    
 
    if(hasError){
        return(
            <Error />
        );
    };
    
    
    if(isLoading){
        return(
            <Loading />
        );
    };   


    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth={true} maxWidth="md" open={showSupplierModal} onClose={()=>{setShowSupplierModal(false);}}>
            <DialogTitle>Supplier</DialogTitle>
            <DialogContent>
                <Box>
                    <CustomerLoadsEditSupplierLookup data={supplier} setValueFx={setSupplierVal} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowSupplierModal(false);}} sx={{mr:2}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth={true} maxWidth="md" open={showReelTypeModal} onClose={()=>{setShowReelTypeModal(false);}}>
            <DialogTitle>Reel Type</DialogTitle>
            <DialogContent>
                <Box>
                    <CustomerLoadsEditReelTypeLookup data={reelType} setValueFx={setReelTypeVal} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowReelTypeModal(false);}} sx={{mr:2}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth={true} maxWidth="md" open={showReelModal} onClose={()=>{setShowReelModal(false);}}>
            <DialogTitle>Reel</DialogTitle>
            <DialogContent>
                <Box>
                    <CustomerLoadsEditReelLookup data={reel} setValueFx={setReelVal} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowReelModal(false);}} sx={{mr:2}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth={true} maxWidth="md" open={showProductModal} onClose={()=>{setShowProductModal(false);}}>
            <DialogTitle>Product</DialogTitle>
            <DialogContent>
                <Box>
                    <CustomerLoadsEditProductLookup data={product} setValueFx={setProductVal} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowProductModal(false);}} sx={{mr:2}}>Close</Button>
            </DialogActions>
        </Dialog> 
        <Dialog fullWidth={true} maxWidth="sm" open={showTrackerModal} onClose={()=>{setShowTrackerModal(false);}}>
            <DialogTitle>Tracker</DialogTitle>
            <DialogContent>
                <CustomerLoadsEditTrackerLookup tracker={tracker} setValueFx={setTrackerVal} />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowTrackerModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>                                       
        <Box>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
            <form id="CustomerLoadsForm" onSubmit={handleSubmit}>
                <Box maxWidth="md" sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Box id="smBox" maxWidth="sm" sx={{width:smallForm?'auto':'600px'}}>
                <Box id="Supplier" sx={{display:'flex', alignItems:'center'}}>
                    <TextField
                        id="tbSupplier"
                        margin="normal"
                        fullWidth
                        label="Supplier"
                        size="small"
                        required
                        value={supplier==null?'':supplier.name}
                        onClick={setShowSupplierModal}
                    />
                    <Box sx={{ml:1, mt:1}}>            
                        <Button variant="contained" onClick={setShowSupplierModal}>
                            <SearchIcon sx={{fontSize:'2em'}} />
                        </Button>
                    </Box>            
                </Box> 
                <Box id="Product" sx={{display:'flex', alignItems:'center'}}>
                    <TextField
                        id="tbProduct"
                        margin="normal"
                        fullWidth
                        label="Product"
                        size="small"
                        required
                        value={product==null?'':product.name}
                        onClick={setShowProductModal}
                    />
                    <Box sx={{ml:1, mt:1}}>            
                        <Button variant="contained" onClick={setShowProductModal}>
                            <SearchIcon sx={{fontSize:'2em'}} />
                        </Button>
                    </Box>            
                </Box> 
                <Box id="ReelType" sx={{display:'flex', alignItems:'center'}}>
                    <TextField
                        id="tbReelType"
                        margin="normal"
                        fullWidth
                        label="Reel Type"
                        size="small"
                        required
                        value={reelType==null?'':reelType.name}
                        onClick={setShowReelTypeModal}
                    />
                    <Box sx={{ml:1, mt:1}}>            
                        <Button variant="contained" onClick={setShowReelTypeModal}>
                            <SearchIcon sx={{fontSize:'2em'}} />
                        </Button>
                    </Box>            
                </Box>
                <Box id="Reel" sx={{display:'flex', alignItems:'center'}}>
                    <TextField
                        id="tbReel"
                        margin="normal"
                        fullWidth
                        label="Reel"
                        size="small"
                        value={reel==null?'':reel.serialNumber + " (" + reel.reelType.name + ")"}
                        onClick={setShowReelModal}
                    />
                    <Box sx={{ml:1, mt:1}}>            
                        <Button variant="contained" onClick={setShowReelModal}>
                            <SearchIcon sx={{fontSize:'2em'}} />
                        </Button>
                    </Box>            
                </Box>
                <Box id="Tracker" sx={{display:'flex', alignItems:'center', width:'100%'}}>
                    <TextField
                        id="tbTracker"
                        margin="normal"
                        fullWidth
                        label="Tracker"
                        size="small"
                        required
                        value={tracker==null?'':tracker.esn}
                        onClick={setShowTrackerModal}
                    />
                    <Box sx={{ml:1, mt:1}}>            
                        <Button variant="contained" onClick={setShowTrackerModal}>
                            <SearchIcon sx={{fontSize:'2em'}} />
                        </Button>
                    </Box>            
                </Box>                                                
                <CustomerLoadsEditUomList uom={uom} setUomFx={setUom} />
                <TextField
                    id="tbAmount"
                    type="number"
                    margin="normal"
                    fullWidth
                    label="Length (ft)"
                    size="small"
                    required
                    value={amt}
                    onChange={(e) => {props.setFormDirtyFx(1); setAmt(e.target.value);}}
                    sx={{flex:1, mr:1}}
                />
                <DatePicker
                    id="tbShipDate"
                    label="Ship Date *"
                    inputFormat="MM/dd/yyyy"
                    value={shipDate}
                    required
                    onChange={(val) => setShipDate(val)}
                    renderInput={(params) => <TextField margin="normal" required size="small" {...params} />}
                    sx={{mt:2}}
                />  
                <Typography variant="h6" sx={{mt:2, mb:1}}>Reel Deferral</Typography>
                <TextField
                    id="tbDeferralPeriod"
                    margin="none"
                    fullWidth
                    label="Deferral Period (Months)"
                    size="small"
                    value={deferralPeriod}
                    onChange={(e) => {props.setFormDirtyFx(1); setDeferralPeriod(e.target.value);}}
                />
                <Typography variant="h6" sx={{mt:2, mb:1}}>Weights</Typography>
                <TextField
                    id="tbNetWeight"
                    margin="none"
                    fullWidth
                    label="Net Weight"
                    size="small"
                    value={netWeight}
                    onChange={(e) => {props.setFormDirtyFx(1); setNetWeight(e.target.value);}}
                />
                <TextField
                    id="tbTareWeight"
                    margin="normal"
                    fullWidth
                    label="Tare Weight"
                    size="small"
                    value={tareWeight}
                    onChange={(e) => {props.setFormDirtyFx(1); setTareWeight(e.target.value);}}
                />                
                <TextField
                    id="tbGrossWeight"
                    margin="normal"
                    fullWidth
                    label="Gross Weight"
                    size="small"
                    value={grossWeight}
                    onChange={(e) => {props.setFormDirtyFx(1); setGrossWeight(e.target.value);}}
                />                
                <Box sx={{textAlign:'center', mt:3}}>
                    <Button variant="contained" disabled={props.formDirty===1?false:true}  type="submit" sx={{mr:2}}>Save</Button>
                </Box>
                </Box>
                </Box>
            </form>
            </LocalizationProvider>
        </Box>
        </>
    );

}
